import { ThemeOptions, createTheme } from "@mui/material/styles";
import { palette as lightPalette } from "./palette";
import { typography } from "./typography";
import { sharedPalette } from "../shared/palette";

const themeOptions: ThemeOptions = {
  palette: {
    ...lightPalette,
    ...sharedPalette,
  },
  typography,
};

export const lightTheme = createTheme(themeOptions);
